var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiIconButton from '@mui/material/IconButton';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
/**
 * Pigment [IconButton](https://pigment.customink.com/?path=/docs/components-iconbutton)
 */
var IconButton = React.forwardRef(function (_a, ref) {
    var _b = _a.fill, fill = _b === void 0 ? false : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, sx = _a.sx, props = __rest(_a, ["fill", "color", "sx"]);
    var fillColor = fill
        ? designTokens.color.shade.white.value
        : 'transparent';
    return (React.createElement(MuiIconButton, __assign({ sx: __assign({ backgroundColor: fillColor }, sx), ref: ref, color: color }, props)));
});
export default IconButton;
//# sourceMappingURL=IconButton.js.map